import { combineReducers } from "redux";
import authReducer from "./authReducer";
import cartReducer from "./cartReducer";
import menuReducer from "./menuReducer";
import qrReducer from "./qrReducer";
import ordersReducer from "./ordersReducer";
import uiReducer from "./uiReducer";

export default combineReducers({
  auth: authReducer,
  menu: menuReducer,
  cart: cartReducer,
  qrInfo: qrReducer,
  orders: ordersReducer,
  UI: uiReducer,
});
